import { useEffect } from 'react';

import { useMembership } from '@ocx/data-membership';

export const useHomeMembershipRefreshEffect = () => {
  const { refetch } = useMembership();

  useEffect(() => {
    refetch();
  }, [refetch]);
};
